export const styles = {
    container: {
        flex: 1
    }
};
